<style>
  .card-header-formatting {
    padding-top: 16px;
    padding-bottom: 16px;
    background: linear-gradient(112.2deg, var(--sl-color-primary-400) 14.86%, var(--sl-color-primary-700) 102.08%);
    color: white;
  }
  .card-header-formatting a:visited{
    color: #f7be6a;
  }

  </style>

<div *ngIf="!error">
    <fadv-box mb="xxx-large">
    <fadv-card>
        <fadv-card-header>
            <div  class="card-header-formatting">
            <fadv-grid>
            <fadv-grid-row>
                <fadv-grid-column>
                    <fadv-box p="small">
                        <fadv-typography style="text-align: center;" type="heading-small">Welcome {{ this.displayedFirstName }}!!</fadv-typography>
                    </fadv-box>
                </fadv-grid-column>
            </fadv-grid-row>
            <fadv-grid-row>
                <fadv-grid-col>
                    <fadv-typography style="text-align: center;" type="paragraph-medium">We need just a little bit of information from you to begin the background check being requested by {{ clientName }} </fadv-typography>
                </fadv-grid-col>
            </fadv-grid-row>
        </fadv-grid>
        </div>
        </fadv-card-header>

        <fadv-box p='large'>
            <form [formGroup]="form" (ngSubmit)="onSubmit()">

                <app-candidate-details (notifyParentDob)="setDob($event)" (notifyParentSSN)="setSSN($event)" [disableFirstName]="disableFirstName"
                    [disableLastName]="disableLastName" [requireMiddleName]="requireMiddleName" [requireDL]="requireDL"
                    [candidate]="candidate" [order]="'invite'">
                </app-candidate-details>

                <fadv-box mt="large">
                    <app-addresscurrent [countries]="countries" [states]="states" [selectedState]="selectedState"
                        [currentAddress]="currentAddress" [selectedCounty]="selectedCounty" [counties]="counties" (zipCodeChange)="handleZipCodeChange($event)">
                    </app-addresscurrent>
                </fadv-box>

                <fadv-box mt="large">
                    <app-addressprevious [loading]="loading" [formGroup]="orderForm" [previousAddresses]="previousAddresses" (onSubmit)="addPreviousAddress()" (onRemove)="removePreviousAddress($event)"></app-addressprevious>
                </fadv-box>

                <fadv-box mt="large">
                    <app-employment *ngIf="employmentRequired" [employmentFormInvalid]="employmentFormInvalid" [loading]="loading" [formGroup]="employment" [states]="states" [previousEmployers]="previousEmployers" (onSubmit)="addPreviousEmployer()" (endDateValidator)="endDateValidator($event)" (onRemove)="removePreviousEmployer($event)"></app-employment>
                 </fadv-box>
                 
                 <fadv-box mt="large">
                    <app-education *ngIf="educationRequired" [educationFormInvalid]="educationFormInvalid" [loading]="loading" [formGroup]="education" [states]="states" [institutions]="institutions" [levelsOfEducation]="levelsOfEducation" (diplomaAwarded)="diplomaAwarded($event)" (onSubmit)="addEducation()" (onRemove)="removeEducation($event)"></app-education>
                 </fadv-box>

                <fadv-box mv="large">
                    <fadv-grid>
                        <fadv-grid-row>
                            <fadv-grid-col alignment="center">
                                <fadv-button style="width:200px; height:44px;" [loading]="loading" [active]="loading" [disabled]="loading || form.invalid"  variant='primary' (click)="onSubmit()" type="button" name="candidate-next-button">Next</fadv-button>
                            </fadv-grid-col>
                        </fadv-grid-row>
                    </fadv-grid>
                </fadv-box>
            </form>
        </fadv-box>
    </fadv-card>
</fadv-box>
</div>

<div *ngIf="error">
    <fadv-card>
        <fadv-box p='large'>
           <fadv-typography>{{errorMessage}}</fadv-typography>
        </fadv-box>
    </fadv-card>
</div>

<div class="spinnerContainer" *ngIf="loading == true">
    <fadv-loader [duration]="2200" open="true"></fadv-loader>
  </div>
